import axios from 'axios'
import { getHeaders } from '../../config'

// The one tracking request that cannot go through the house helpers: they cannot send an extra
// header, and a re-track without its `Idempotency-Key` is refused by the server (and would, if it
// were not, be a second ShipsGo credit on every retry).
//
// It also fires no toast of its own. RetrackModal reports every outcome itself — a confirmed
// refusal, a 202, and the "we could not confirm" case where the request may well have been carried
// out — and a generic "Error creating retrack, retry." on top of that would be telling the operator
// to do the one thing that could cost a second credit.
export const postWithIdempotencyKey = async (url, payload, key) => {
  try {
    const response = await axios.post(url, payload, {
      headers: { ...getHeaders(), 'Idempotency-Key': key }
    })
    return { success: true, data: response.data, status: response.status }
  } catch (error) {
    return { success: false, error }
  }
}
